export const getNormalFormProps = (formProps: any) => {
  const props = { ...formProps };
  
  delete props.resolveFn;
  delete props.validators;
  delete props.onSubmitClick;

  return props;
};
